import { setStoredReservationToken } from './session-storage'

export function persistReservationTokenFromElement(element: Element | null): void {
    const reservationToken = element?.getAttribute('reservation-token')

    if (!reservationToken) {
        return
    }

    setStoredReservationToken(reservationToken)
}
